import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  LIST_VIEW_ACTIONS,
  ListViewMode,
  selectListViewState,
  selectSelectedListProductNumbers,
} from '@usf/ngrx-list';
import { EASY_PRICING_ACTIONS } from '@usf/ngrx-pricing';
import { filter, map, withLatestFrom } from 'rxjs';

@Injectable()
export class ClientListViewEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
  ) {}

  loadPmeForList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        LIST_VIEW_ACTIONS.selectList,
        LIST_VIEW_ACTIONS.changeListViewMode,
      ),
      withLatestFrom(this.store.select(selectSelectedListProductNumbers)),
      filter(
        ([action, selectedListProductNumbers]) =>
          selectedListProductNumbers.selectedListViewMode ===
            ListViewMode.pricing &&
          selectedListProductNumbers.selectedListType !== null,
      ),
      map(([action, selectedListProductNumbers]) =>
        EASY_PRICING_ACTIONS.loadEasyPricing({
          productNumbers: selectedListProductNumbers.productNumbers,
        }),
      ),
    ),
  );
}
